import { ConfigRoutes } from '@shared/models/general/utils.interface';

interface AccesosProduccion {
    PEDIDO_MATERIALES: ConfigRoutes
    PEDIDO_MATERIALES_REGISTRO: ConfigRoutes
    PEDIDO_MATERIALES_MODIFICAR: ConfigRoutes
    ORDEN_PRODUCCION: ConfigRoutes
    ORDEN_PRODUCCION_REGISTRO: ConfigRoutes
    ORDEN_PRODUCCION_MODIFICAR: ConfigRoutes
    ORDEN_PRODUCCION_AJUSTAR: ConfigRoutes
    ORDEN_TRABAJO: ConfigRoutes
    ORDEN_TRABAJO_REGISTRO: ConfigRoutes
    ORDEN_TRABAJO_MODIFICAR: ConfigRoutes
    GUIA_INTERNA: ConfigRoutes
    GUIA_SALIDA_OP_REGISTRO: ConfigRoutes
    GUIA_INGRESO_OP_REGISTRO: ConfigRoutes
    GUIA_INGRESO_DEVOLUCION_REGISTRO: ConfigRoutes
    GUIA_SERVICIO_PRODUCCION_REGISTRO: ConfigRoutes
    MATERIALES_ESTANDAR: ConfigRoutes
    CERTIFICADO_CALIDAD: ConfigRoutes
    CERTIFICADO_CALIDAD_REGISTRO: ConfigRoutes
    CERTIFICADO_CALIDAD_MODIFICAR: ConfigRoutes
    LIQUIDACION: ConfigRoutes
    LIQUIDACION_OP: ConfigRoutes
    LIQUIDACION_OT: ConfigRoutes
    REPORTES: ConfigRoutes
    REPORTE_INGRESOS_SALIDAS_OP: ConfigRoutes
    REPORTE_INGRESOS_SALIDAS_OT: ConfigRoutes
    REPORTE_DISTRIBUCION_COSTOS: ConfigRoutes
    REPORTE_DISTRIBUCION_COSTOS_GUIA: ConfigRoutes
    SOPORTE: ConfigRoutes
    PROCESOS: ConfigRoutes
    PROCESO_CALCULO_PRODUCCION: ConfigRoutes
    PROCESO_CALCULO_PRODUCCION_GUIA: ConfigRoutes
    PROCESO_COSTO_TRABAJO: ConfigRoutes
    ACTUALIZACION_MANUAL_COSTOS: ConfigRoutes
}

interface ModuloProduccion {
    ID: number
    ACCESOS: AccesosProduccion
}

const pathModulo = '/produccion/'

export const MODULO_PRODUCCION: ModuloProduccion = {
    ID: 15,
    ACCESOS: {
        PEDIDO_MATERIALES: {
            TITLE: 'Pedido de materiales',
            ACCESS: 218,
            PATH_MODULE: pathModulo,
            DESCRI: 'Consulta de pedido de materiales',
            ROUTE: 'pedido-materiales'
        },
        PEDIDO_MATERIALES_REGISTRO: {
            TITLE: 'Registro de pedido de materiales',
            ACCESS: 218,
            PATH_MODULE: pathModulo,
            DESCRI: 'Registro de pedido de materiales',
            ROUTE: 'pedido-materiales/nuevo'
        },
        PEDIDO_MATERIALES_MODIFICAR: {
            TITLE: 'Modificar pedido de materiales',
            ACCESS: 218,
            PATH_MODULE: pathModulo,
            ROUTE: 'pedido-materiales/modificar'
        },
        ORDEN_PRODUCCION: {
            TITLE: 'Orden de producción',
            ACCESS: 201,
            PATH_MODULE: pathModulo,
            DESCRI: 'Consulta de orden de producción',
            ROUTE: 'orden-produccion'
        },
        ORDEN_PRODUCCION_REGISTRO: {
            TITLE: 'Registro de orden de producción',
            ACCESS: 201,
            PATH_MODULE: pathModulo,
            DESCRI: 'Registro de orden de producción',
            ROUTE: 'orden-produccion/nuevo'
        },
        ORDEN_PRODUCCION_MODIFICAR: {
            TITLE: 'Modificar orden de producción',
            ACCESS: 201,
            PATH_MODULE: pathModulo,
            ROUTE: 'orden-produccion/modificar'
        },
        ORDEN_PRODUCCION_AJUSTAR: {
            TITLE: 'Ajustar producción',
            ACCESS: 201,
            PATH_MODULE: pathModulo,
            ROUTE: 'orden-produccion/ajustar'
        },
        ORDEN_TRABAJO: {
            TITLE: 'Orden de trabajo / servicio',
            ACCESS: 219,
            PATH_MODULE: pathModulo,
            DESCRI: 'Consulta de orden de trabajo',
            ROUTE: 'orden-trabajo'
        },
        ORDEN_TRABAJO_REGISTRO: {
            TITLE: 'Registro de orden de trabajo',
            ACCESS: 219,
            PATH_MODULE: pathModulo,
            DESCRI: 'Registro de orden de trabajo',
            ROUTE: 'orden-trabajo/nuevo'
        },
        ORDEN_TRABAJO_MODIFICAR: {
            TITLE: 'Modificar orden de trabajo',
            ACCESS: 219,
            PATH_MODULE: pathModulo,
            ROUTE: 'orden-trabajo/modificar'
        },
        GUIA_INTERNA: {
            TITLE: 'Guías internas',
            ACCESS: 303,
            PATH_MODULE: pathModulo,
            DESCRI: 'Consulta de guías internas de producción',
            ROUTE: 'guia-interna'
        },
        GUIA_SALIDA_OP_REGISTRO: {
            TITLE: 'Guía de salida por orden de producción',
            ACCESS: 303,
            PATH_MODULE: pathModulo,
            DESCRI: 'Registro de guía de salida por OP',
            ROUTE: 'guia-salida-op/nuevo'
        },
        GUIA_INGRESO_OP_REGISTRO: {
            TITLE: 'Guía de ingreso por orden de producción',
            ACCESS: 303,
            PATH_MODULE: pathModulo,
            DESCRI: 'Registro de guía de ingreso por OP',
            ROUTE: 'guia-ingreso-op/nuevo'
        },
        GUIA_INGRESO_DEVOLUCION_REGISTRO: {
            TITLE: 'Guía de ingreso por devolución',
            ACCESS: 303,
            PATH_MODULE: pathModulo,
            DESCRI: 'Registro de guía de ingreso por devolución',
            ROUTE: 'guia-ingreso-devolucion/nuevo'
        },
        GUIA_SERVICIO_PRODUCCION_REGISTRO: {
            TITLE: 'Guía de servicio de producción',
            ACCESS: 303,
            PATH_MODULE: pathModulo,
            DESCRI: 'Registro de guía de servicio de producción',
            ROUTE: 'guia-servicio-produccion/nuevo'
        },
        MATERIALES_ESTANDAR: {
            TITLE: 'Materiales estándar',
            ACCESS: 202,
            PATH_MODULE: pathModulo,
            ROUTE: 'materiales-estandar'
        },
        CERTIFICADO_CALIDAD: {
            TITLE: 'Certificados de calidad',
            ACCESS: 204,
            PATH_MODULE: pathModulo,
            DESCRI: 'Consulta de certificados de calidad',
            ROUTE: 'certificado-calidad'
        },
        CERTIFICADO_CALIDAD_REGISTRO: {
            TITLE: 'Registro de certificado de calidad',
            ACCESS: 204,
            PATH_MODULE: pathModulo,
            DESCRI: 'Registro de certificado de calidad',
            ROUTE: 'certificado-calidad/nuevo'
        },
        CERTIFICADO_CALIDAD_MODIFICAR: {
            TITLE: 'Modificar certificado de calidad',
            ACCESS: 204,
            PATH_MODULE: pathModulo,
            ROUTE: 'certificado-calidad/modificar'
        },
        LIQUIDACION: {
            TITLE: 'Liquidación',
            ACCESS: 203
        },
        LIQUIDACION_OP: {
            TITLE: 'Órdenes de producción',
            ACCESS: 203,
            PATH_MODULE: pathModulo,
            DESCRI: 'Liquidación de órdenes de producción',
            ROUTE: 'liquidacion/orden-produccion'
        },
        LIQUIDACION_OT: {
            TITLE: 'Órdenes de trabajo',
            ACCESS: 203,
            PATH_MODULE: pathModulo,
            DESCRI: 'Liquidación de órdenes de trabajo',
            ROUTE: 'liquidacion/orden-trabajo'
        },
        REPORTES: {
            TITLE: 'Reportes',
            ACCESS: 201,
            PATH_MODULE: pathModulo,
            DESCRI: 'Reportes de producción',
            ROUTE: 'reportes'
        },
        REPORTE_INGRESOS_SALIDAS_OP: {
            TITLE: 'Ingresos y salidas por orden de producción',
            ACCESS: 201,
            PATH_MODULE: `${pathModulo}reportes/`,
            DESCRI: 'Reporte de ingresos y salidas por orden de producción',
            ROUTE: 'ingresos-salidas-orden-produccion'
        },
        REPORTE_INGRESOS_SALIDAS_OT: {
            TITLE: 'Ingresos y salidas por orden de trabajo',
            ACCESS: 201,
            PATH_MODULE: `${pathModulo}reportes/`,
            DESCRI: 'Reporte de ingresos y salidas por orden de trabajo',
            ROUTE: 'ingresos-salidas-orden-trabajo'
        },
        REPORTE_DISTRIBUCION_COSTOS: {
            TITLE: 'Distribución de costos',
            ACCESS: 322,
            PATH_MODULE: `${pathModulo}reportes/`,
            DESCRI: 'Reporte de distribución de costos',
            ROUTE: 'distribucion-costos'
        },
        REPORTE_DISTRIBUCION_COSTOS_GUIA: {
            TITLE: 'Distribución de costos por G.I.',
            ACCESS: 323,
            PATH_MODULE: `${pathModulo}reportes/`,
            DESCRI: 'Reporte de distribución de costos por guía interna',
            ROUTE: 'distribucion-costos-guia'
        },
        SOPORTE: {
            TITLE: 'Soporte',
            ACCESS: 201,
            ROUTE: 'soportes'
        },
        PROCESOS: {
            TITLE: 'Procesos',
            ACCESS: 201,
            PATH_MODULE: pathModulo,
            DESCRI: 'Soporte - Procesos de producción',
            ROUTE: 'soportes/procesos'
        },
        PROCESO_CALCULO_PRODUCCION: {
            TITLE: 'Cálculo de producción',
            ACCESS: 320,
            PATH_MODULE: `${pathModulo}soportes/procesos/`,
            DESCRI: 'Soporte - Cálculo de producción',
            ROUTE: 'calculo-produccion'
        },
        PROCESO_CALCULO_PRODUCCION_GUIA: {
            TITLE: 'Cálculo de producción por G.I.',
            ACCESS: 321,
            PATH_MODULE: `${pathModulo}soportes/procesos/`,
            DESCRI: 'Soporte - Cálculo de producción por guía interna',
            ROUTE: 'calculo-produccion-guia'
        },
        PROCESO_COSTO_TRABAJO: {
            TITLE: 'Costo de trabajo',
            ACCESS: 201,
            PATH_MODULE: `${pathModulo}soportes/procesos/`,
            DESCRI: 'Soporte - Costo de trabajo',
            ROUTE: 'costo-trabajo'
        },
        ACTUALIZACION_MANUAL_COSTOS: {
            TITLE: 'Actualización manual de costos',
            ACCESS: 201,
            PATH_MODULE: pathModulo,
            DESCRI: 'Soporte - Actualización manual de costos',
            ROUTE: 'soporte/actualizacion-manual-costos'
        }
    }
}

export const MODULO_PRODUCCION_BUSQUEDA = Object.entries(MODULO_PRODUCCION.ACCESOS).filter(item => item[1].DESCRI != null)
